import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useSidebar } from '@/context/SidebarContext';

const Layout = ({ children, title, subtitle, breadcrumbs }) => {
  const { collapsed } = useSidebar();

  return (
    <div className="flex h-screen bg-gray-50">
      <div className={`${collapsed ? 'w-[68px]' : 'w-64'} flex-shrink-0 transition-all duration-200`}>
        <Sidebar />
      </div>
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title={title} subtitle={subtitle} breadcrumbs={breadcrumbs} />
        <main className="flex-1 overflow-y-auto bg-gray-50 p-8">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
